export default class SearchDropdown {

    constructor() {

        this.settings = {
            $searchIcon : $('.js-search-icon')
        };

        this.bindUIActions();

    }

    bindUIActions() {

        if(this.settings.$searchIcon != null ) {
            this.settings.$searchIcon.on('click', (e) => {
                const $this = $(e.currentTarget);
                $this.toggleClass('p-2 lg:p-4 bg-elfs-navy rounded-full transition-all duration-500');
                $('body').toggleClass('overflow-hidden');
                $(document).ready(function() {
                    let headerHeight = $('header.header').height();
                    $('.js-search-dropdown').css({'height': 'calc(100vh - ' +headerHeight + 'px)', 'overflow-y': 'auto'});
                });
            });

            $('.js-search-close').on('click',  () => {
                this.settings.$searchIcon.removeClass('p-2 lg:p-4 bg-elfs-navy rounded-full transition-all duration-500');
                $('.js-search-dropdown').css({'height': '0', 'overflow': 'hidden'});
                $('body').removeClass('overflow-hidden');
            });
        }

    }

};

new SearchDropdown();